import { Drawer, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useInfoDrawer } from 'context/InfoDrawerContext';
import { Button } from 'components/Button';

export function InfoDrawer() {
  const { isOpen, drawerContent, closeDrawer } = useInfoDrawer();

  if (!drawerContent) {
    return null;
  }

  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={closeDrawer}
      sx={{
        '& .MuiDrawer-paper': {
          width: '400px',
          maxWidth: '80vw',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      <div className="mb-6 flex items-start justify-between px-6 pt-6">
        <div className="flex min-w-0 flex-col gap-3">
          <Typography
            variant="h3"
            component="h2"
            sx={{ fontSize: '20px', lineHeight: '28px', fontWeight: 400, overflowWrap: 'break-word' }}
          >
            <FormattedMessage id={drawerContent.titleKey} />
          </Typography>
          {drawerContent.subtitleKey && (
            <Typography variant="body2" sx={{ color: 'text.disabled', fontWeight: 300, overflowWrap: 'break-word' }}>
              <FormattedMessage id={drawerContent.subtitleKey} />
            </Typography>
          )}
        </div>
        <Button icon="Cross" className="shrink-0" onClick={closeDrawer} />
      </div>
      <hr className="w-full border-t border-gray-200" />
      <div className="min-w-0 flex-grow overflow-auto px-6 pt-6 [&_*]:break-words">{drawerContent?.content}</div>
    </Drawer>
  );
}
